import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/consumable/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/consumable/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/v4ward/consumable/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/consumable/save', params,options);

export const update = (params, options) =>
request.post('/api/v4ward/consumable/update', params,options);



export const getListWithNoPicture = (params, options) =>
request.get('/api/v4ward/repair/task/device/selectConsumable', Object.assign({}, options, { params }));